import { Box, Icon, ImageList, ImageListItem, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useAppenderStyle } from './appender.style';
import { INodeByTagProps } from './interface/appender.interface';
import { INodeTemplate } from '@/types/node';

const NodeByTag = ({ tag, templates, enabled, onSelect, nodeId }: INodeByTagProps) => {
  const s = useAppenderStyle(useTheme());

  return (
    <ImageList gap={4} cols={4} sx={{ rowHeight: 'auto' }}>
      {Object.values(templates)
        .filter((t) => t.tag === tag && t.supports.appender)
        .map((template) => (
          <ImageListItem
            key={template.type}
            title={template.name}
            onClick={() => enabled(template.type) && onSelect(template, nodeId)}
          >
            <Box
              sx={{
                ...s.item,
                ...(!enabled(template.type) && s.disabled),
              }}
            >
              <Icon color="inherit" fontSize="large">
                {template.icon}
              </Icon>
              <Typography color="textPrimary">{template.name}</Typography>
            </Box>
          </ImageListItem>
        ))}
    </ImageList>
  );
};

export default NodeByTag;
